// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__UBSOY","title":"AfterImages45_title__30boW","images":"AfterImages45_images__bsPVq"};